<div>
  <button
    (click)="handleClick()"
    class="flex items-center gap-8 bg-none border-0"
    type="button"
  >
    <img
      class="aspect-square object-contain rounded-full"
      [src]="speaker.profilePicture ? speaker.profilePicture : '/assets/images/persona.png'"
      height="48"
      width="48"
    />
    <h3 class="h5 text-orange">
      {{ speaker.firstName }} {{ speaker.lastName }}
    </h3>
  </button>
</div>
